import { createFileRoute, useParams } from '@tanstack/react-router';
import { AppBundle } from '@/utils/app-bundles';
import Journeys from '@/pages/journeys';
import { JourneysDataIndexHandoff } from '@/pages/workspaces/data-index/routing';
import { DataIndexTypeResolver } from '@/pages/workspaces/data-index/data-index-type-resolver';
import { LastWorkspaceResolver } from './-route-layouts';

function JourneysDataIndexTypeRoute() {
  const { type } = useParams({ from: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type' });

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      {/* A segment this page does not serve stays with the embedded app,
          which bounces it itself. Redirecting from here would park the
          transition: ownership leaves the URL to that app, so nothing would
          mount the host the navigation waits on. */}
      <DataIndexTypeResolver segment={type} fallback={<Journeys />}>
        {(dataIndexType) => <JourneysDataIndexHandoff type={dataIndexType} />}
      </DataIndexTypeResolver>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/data-index/$type')({
  component: JourneysDataIndexTypeRoute,
});
